import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

import { QUERY_KEY as GET_COMMUNITIES_QUERY_KEY } from './useGetCommunities';

const METHOD = 'POST';
const ENDPOINT = 'communities/{id}/leave';

export const useLeaveCommunity = () => {
  const { session } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: { communityId: number }) => {
      try {
        const data = await handleApiCall<unknown>(
          session,
          METHOD,
          getResolvedEndpoint(ENDPOINT, { id: params.communityId.toString() })
        );

        return data;
      } catch (err) {
        enqueueSnackbar('Failed to leave community.', { variant: 'error' });
        throw err;
      }
    },
    onSuccess: (_, variables) => {
      enqueueSnackbar('Successfully left community!', { variant: 'success' });
      
      // Invalidate relevant queries
      queryClient.invalidateQueries({
        queryKey: ['community', variables.communityId],
      });
      queryClient.invalidateQueries({ queryKey: GET_COMMUNITIES_QUERY_KEY() });
      queryClient.invalidateQueries({
        queryKey: ['community', 'activities', variables.communityId],
      });
    },
  });
};